import type { ChatProvider, ChatProviderId } from '@/composables/chat/types'
import { setupAgentforceChat } from '@/composables/chat/providers/agentforce/setup-agentforce-chat'
import { setupZowieChat } from '@/composables/chat/providers/zowie/setup-zowie-chat'

type ApiCall = (...args: unknown[]) => Promise<unknown>

export type ChatProviderSetupDeps = {
  apiCall: ApiCall
  businessId: number
}

type ChatProviderSetup = (deps: ChatProviderSetupDeps) => Promise<ChatProvider>

const CHAT_PROVIDER_SETUP: Record<ChatProviderId, ChatProviderSetup> = {
  zowie: setupZowieChat,
  agentforce: setupAgentforceChat,
}

export const DEFAULT_CHAT_PROVIDER_ID: ChatProviderId = 'zowie'

export async function setupChatProvider (
  id: ChatProviderId,
  deps: ChatProviderSetupDeps
): Promise<ChatProvider> {
  return CHAT_PROVIDER_SETUP[id](deps)
}
